import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const HeartIcon: FunctionComponent<IconProps> = ({
  selected,
  fill,
  width = 16,
  height = 16,
  ...rest
}) => {
  return (
    <Icon
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path
        d="M15 5.40397V5.40684C15 6.32473 14.6445 7.1828 13.9944 7.83328C13.9942 7.8335 13.994 7.83371 13.9937 7.83392L7.99733 13.808L2.00965 7.82035C1.35711 7.16781 1.00002 6.31207 1.00002 5.39666L1.00001 5.3938C0.997389 4.47768 1.35223 3.62021 2.00286 2.96958C2.64991 2.32253 3.5082 1.96674 4.42316 1.96674C5.3402 1.96674 6.20225 2.32498 6.85363 2.97636L7.29798 3.42071L8.00509 4.12782L8.71219 3.42071L9.14976 2.98315C9.80032 2.33258 10.6587 1.97691 11.5768 1.97691C12.4962 1.97691 13.3508 2.33001 14.0005 2.97975C14.6498 3.62899 15.0026 4.48589 15 5.40397ZM7.61004 14.1939C7.61048 14.1934 7.61092 14.193 7.61136 14.1926L7.61004 14.1939Z"
        strokeWidth="2"
        className={classnames(
          styles.interactiveStrokeColor,
          selected ? styles.interactiveColor : styles.white
        )}
      />
    </Icon>
  )
}
